import { Input as ChakraInput, InputProps } from '@chakra-ui/react'

function Input(props: InputProps) {
  return (
    <ChakraInput {...props} autocapitalize="off"/>
  )
}

export default Input